import { FC } from 'react'
import {
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/shared/ui/Alert/AlertDialog'
import { AlertDialog, AlertDialogProps } from '@radix-ui/react-alert-dialog'
import { useDeleteContact } from '../lib/use-delete-contact'
import { Loader } from '@mantine/core'
import { useTranslation } from 'react-i18next'

type DeleteContactAlertProps = {
  selectContactId: number
  onCloseModal: () => void
}

export const DeleteContactAlert: FC<DeleteContactAlertProps & AlertDialogProps> = ({
  selectContactId,
  onCloseModal,
  ...props
}) => {
  const { isLoadingDelete, handleDeleteContact } = useDeleteContact()
  const { t } = useTranslation(['contact'])

  return (
    <AlertDialog {...props}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('contact:confirmation.are_you_absolutely_sure')}</AlertDialogTitle>
          <AlertDialogDescription>
            {t('contact:confirmation.action_cannot_be_undone')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoadingDelete}>
            {t('residential:buttons.cancel')}
          </AlertDialogCancel>
          <AlertDialogAction
            disabled={isLoadingDelete}
            className='bg-red hover:bg-red/80'
            onClick={() => handleDeleteContact(selectContactId, onCloseModal)}
          >
            {isLoadingDelete ? <Loader color='white' size='xs' /> : t('residential:buttons.delete')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
